const types = {

    // Search
    GET_SUGGESTIONS: "GET_SUGGESTIONS",
    SET_SEARCH_LOCATION: "SET_SEARCH_LOCATION",
    SET_SHARED_JOURNEY_SEARCH: 'SET_SHARED_JOURNEY_SEARCH',
    SET_UPGRADE_JOURNEYS_SEARCH: 'SET_UPGRADE_JOURNEYS_SEARCH',
    CLOSE_SEARCH_LOCATION: 'CLOSE_SEARCH_LOCATION',
    SET_PREVENT_SEARCH_BLUR: 'SET_PREVENT_SEARCH_BLUR',

    // Process
    SET_NEXT_COMPONENT_ID: "SET_NEXT_COMPONENT_ID",
    SET_FIRST_LOOP_COMPONENT_ID: "SET_FIRST_LOOP_COMPONENT_ID",
    REPLACE_NEXT_COMPONENT: "REPLACE_NEXT_COMPONENT",
    SET_NEXT_COMPONENT_ID_FOR_CONDITION: "SET_NEXT_COMPONENT_ID_FOR_CONDITION",

    ADD_COMPONENT: "ADD_COMPONENT",
    TOGGLE_COMPONENT_MENU: "TOGGLE_COMPONENT_MENU",
    DELETE_COMPONENT: "DELETE_COMPONENT",
    ADD_CONTROL: "ADD_CONTROL",
    ADD_CONTROL_TO_LAYOUT_PANEL: "ADD_CONTROL_TO_LAYOUT_PANEL",
    UPDATE_CONTROL: "UPDATE_CONTROL",
    UPDATE_LAYOUT_PANEL: "UPDATE_LAYOUT_PANEL",
    DELETE_CONTROL: "DELETE_CONTROL",
    DELETE_LAYOUT_PANEL: "DELETE_LAYOUT_PANEL",

    SET_PROCESS_STATE: "SET_PROCESS_STATE",
    UPDATE_PROCESS_STATE: "UPDATE_PROCESS_STATE",
    UPDATE_PROPERTY: "UPDATE_PROPERTY",
    UPDATE_LAYOUT_PANEL_PROPERTY: "UPDATE_LAYOUT_PANEL_PROPERTY",
    UPDATE_COMPONENT_OUTPUT: "UPDATE_COMPONENT_OUTPUT",


    DROP_CONTROL: "DROP_CONTROL",
    DROP_CONTROL_WITH_LAYOUT_PANEL: "DROP_CONTROL_WITH_LAYOUT_PANEL",
    UPDATE_GLOBAL_OUTPUTS: 'UPDATE_GLOBAL_OUTPUTS',
    SET_JOURNEY: 'SET_JOURNEY',

    RESET_COMPONENTS: 'RESET_COMPONENTS',

    DELETE_COMPONENT_CHAIN: 'DELETE_COMPONENT_CHAIN',

    // Sidebar
    TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",
    UPDATE_SIDEBAR: "UPDATE_SIDEBAR",
    TOGGLE_SIDEBAR_PIN: "TOGGLE_SIDEBAR_PIN",

    ADD_BRANCH: "ADD_BRANCH",
    DELETE_BRANCH: "DELETE_BRANCH",
    SET_BRANCH_EDIT_INDEX: "SET_BRANCH_EDIT_INDEX",
    SAVE_EDITED_BRANCH: "SAVE_EDITED_BRANCH",
    UPDATE_EDITED_BRANCH: "UPDATED_EDITED_BRANCH",
    UPDATE_DECISION_BRANCH_RULE_WITH_OUTPUTS: "UPDATE_DECISION_BRANCH_RULE_WITH_OUTPUTS",

    // Modal Dialog
    TOGGLE_DIALOG: "TOGGLE_DIALOG",
    UPDATE_CONTROL_DIALOG: "UPDATE_CONTROL_DIALOG",
    TOGGLE_CONFIRMATION_DIALOG: "TOGGLE_CONFIRMATION_DIALOG",
    SET_MODAL_OVERLAY_MESSAGE: "SET_MODAL_OVERLAY_MESSAGE",

    SAVE_AS_JOURNEY_TITLE_CHANGE: "SAVE_AS_JOURNEY_TITLE_CHANGE",
    SET_MODAL_ERROR_MESSAGES: "SET_MODAL_ERROR_MESSAGES",
    SET_ERROR_MESSAGE_DISMISSED: "SET_ERROR_MESSAGE_DISMISSED",
    SET_MODAL_WARNING_MESSAGES: "SET_MODAL_WARNING_MESSAGES",

    // Controls
    ADD_CONTROL_OPTION: "ADD_CONTROL_OPTION",
    REMOVE_CONTROL_OPTION: "REMOVE_CONTROL_OPTION",
    UPDATE_CONTROL_OPTION: "UPDATE_CONTROL_OPTION",

    ADD_CONTROL_ITEM: "ADD_CONTROL_ITEM",
    REMOVE_CONTROL_ITEM: "REMOVE_CONTROL_ITEM",
    UPDATE_CONTROL_ITEM: "UPDATE_CONTROL_ITEM",

    UPDATE_CONTROL_GLOBAL_OUTPUT: 'UPDATE_CONTROL_GLOBAL_OUTPUT',

    MOVE_CONTROL_OPTION: "MOVE_CONTROL_OPTION",
    SET_MOVE_FROM_CONTROL_OPTION: "SET_MOVE_FROM_CONTROL_OPTION",
    SET_MOVE_OVER_CONTROL_OPTION: "SET_MOVE_OVER_CONTROL_OPTION",

    MOVE_CONTROL_ITEM: "MOVE_CONTROL_ITEM",
    SET_MOVE_FROM_CONTROL_ITEM: "SET_MOVE_FROM_CONTROL_ITEM",
    SET_MOVE_OVER_CONTROL_ITEM: "SET_MOVE_OVER_CONTROL_ITEM",

    UPDATE_CONTROL_OUTPUT: "UPDATE_CONTROL_OUTPUT",
    UPDATE_CONTROL_OUTPUT_LOGICAL_NAME: "UPDATE_CONTROL_OUTPUT_LOGICAL_NAME",
    UPDATE_CONTROL_ADVANCED_SETTINGS_INDEX: 'UPDATE_CONTROL_ADVANCED_SETTINGS_INDEX',
    UPDATE_CONTROL_OUTPUT_DEFAULT_VALUE: 'UPDATE_CONTROL_OUTPUT_DEFAULT_VALUE',
    UPDATE_FORM_FIELD_VALUE: 'UPDATE_FORM_FIELD_VALUE',

    SET_VALIDATION_EDIT_INDEX: 'SET_VALIDATION_EDIT_INDEX',
    UPDATE_EDITED_VALIDATION_ITEM: 'UPDATE_EDITED_VALIDATION_ITEM',

    // Actions
    UPDATE_ACTION_DIALOG: "UPDATE_ACTION_DIALOG",
    UPDATE_ACTION_ENTITY_DIALOG: "UPDATE_ACTION_ENTITY_DIALOG",
    UPDATE_ACTION_OUTPUT: "UPDATE_ACTION_OUTPUT",
    UPDATE_ACTION: "UPDATE_ACTION",
    UPDATE_ACTION_IN_OUTPUT: "UPDATE_ACTION_IN_OUTPUT",
    DELETE_ACTION_OUTPUTS: "DELETE_ACTION_OUTPUTS",
    UPDATE_ACTION_GLOBAL_OUTPUT: 'UPDATE_ACTION_GLOBAL_OUTPUT',
    UPDATE_ACTION_OUTPUT_TYPE: 'UPDATE_ACTION_OUTPUT_TYPE',
    UPDATE_ACTION_OUTPUT_LOGICAL_NAME: 'UPDATE_ACTION_OUTPUT_LOGICAL_NAME',
    UPDATE_ACTION_OUTPUT_STATIC_NAME: 'UPDATE_ACTION_OUTPUT_STATIC_NAME',
    ADD_ACTION_OUTPUT: 'ADD_ACTION_OUTPUT',
    ADD_ACTION_OUTPUT_ARRAY: 'ADD_ACTION_OUTPUT_ARRAY',
    SET_ACTION_OUTPUT_ARRAY: 'SET_ACTION_OUTPUT_ARRAY',
    REMOVE_ACTION_OUTPUT_ARRAY: 'REMOVE_ACTION_OUTPUT_ARRAY',
    SET_ENTITY_OUTPUTS: 'SET_ENTITY_OUTPUTS',
    SET_FETCHXML_OUTPUTS: 'SET_FETCHXML_OUTPUTS',
    SORT_ENTITY_OUTPUTS: 'SORT_ENTITY_OUTPUTS',
    SET_JOURNEY_OUTPUTS: 'SET_JOURNEY_OUTPUTS',
    DELETE_ACTION_OUTPUT: 'DELETE_ACTION_OUTPUT',
    ADD_FIELD: "ADD_FIELD",
    ADD_FIELD_ERROR: "ADD_FIELD_ERROR",
    REMOVE_FIELD_ERROR: "REMOVE_FIELD_ERROR",
    ADD_FIELD_FROM_METADATA: "ADD_FIELD_FROM_METADATA",
    REMOVE_FIELD_FROM_METADATA: "REMOVE_FIELD_FROM_METADATA",
    UPDATE_FIELD_NAME: "UPDATE_FIELD_NAME",
    UPDATE_FIELD_VALUE: "UPDATE_FIELD_VALUE",
    UPDATE_VALUE_OPTIONS_FIELD_VALUE: "UPDATE_VALUE_OPTIONS_FIELD_VALUE",
    SET_IS_FIELD_CHANGED: "SET_IS_FIELD_CHANGED",
    SET_IS_PROPERTY_CHANGED: "SET_IS_PROPERTY_CHANGED",
    UPDATE_FIELD_TYPE: "UPDATE_FIELD_TYPE",
    UPDATE_FIELD_REQUIRED: "UPDATE_FIELD_REQUIRED",
    DELETE_FIELD: "DELETE_FIELD",
    UPDATE_ACTION_ADVANCED_SETTINGS_INDEX: 'UPDATE_ACTION_ADVANCED_SETTINGS_INDEX',
    UPDATE_ACTION_OUTPUT_DEFAULT_VALUE: 'UPDATE_ACTION_OUTPUT_DEFAULT_VALUE',
    UPDATE_GET_RECORD_ACTION_OUTPUT_DEFAULT_VALUE: 'UPDATE_GET_RECORD_ACTION_OUTPUT_DEFAULT_VALUE',
    SET_LOADING_TEMPLATE: 'SET_LOADING_TEMPLATE',
    ADD_ENTITY_OPTION_SET: "ADD_ENTITY_OPTION_SET",
    ADD_ENTITY_STATE_CODE: "ADD_ENTITY_STATE_CODE",
    ADD_STATUS_REASON_SET: "ADD_STATUS_REASON_SET",
    SET_ARE_ENTITY_FORMS_LOADING: "SET_ARE_ENTITY_FORMS_LOADING",
    SET_ARE_ENTITY_VIEWS_LOADING: "SET_ARE_ENTITY_VIEWS_LOADING",

    // Decisions
    UPDATE_DECISION_DIALOG: "UPDATE_DECISION_DIALOG",
    UPDATE_DECISION: "UPDATE_DECISION",

    // Control Blocks
    UPDATE_CONTROL_BLOCK_DIALOG: 'UPDATE_CONTROL_BLOCK_DIALOG',
    UPDATE_CONTROL_BLOCK: 'UPDATE_CONTROL_BLOCK',
    SET_ALL_OUTPUT_REFERENCES: 'SET_ALL_OUTPUT_REFERENCES',
    CREATE_LAYOUT_PANELS: 'CREATE_LAYOUT_PANELS',
    SET_CONTROL_FIELD_FROM_METADATA: "SET_CONTROL_FIELD_FROM_METADATA",


    // Shared Journey
    UPDATE_SHARED_JOURNEY: 'UPDATE_SHARED_JOURNEY',
    SET_SHARED_JOURNEY_CONFIG: 'SET_SHARED_JOURNEY_CONFIG',
    UPDATE_SHARED_JOURNEY_OUTPUT: "UPDATE_SHARED_JOURNEY_OUTPUT",
    DELETE_SHARED_JOURNEY_OUTPUTS: "DELETE_SHARED_JOURNEY_OUTPUTS",
    UPDATE_SHARED_JOURNEY_GLOBAL_OUTPUT: 'UPDATE_SHARED_JOURNEY_GLOBAL_OUTPUT',
    UPDATE_SHARED_JOURNEY_OUTPUT_TYPE: 'UPDATE_SHARED_JOURNEY_OUTPUT_TYPE',
    UPDATE_SHARED_JOURNEY_OUTPUT_LOGICAL_NAME: 'UPDATE_SHARED_JOURNEY_OUTPUT_LOGICAL_NAME',
    UPDATE_SHARED_JOURNEY_OUTPUT_DEFAULT_VALUE: 'UPDATE_SHARED_JOURNEY_OUTPUT_LOGICAL_NAME',
    ADD_SHARED_JOURNEY_OUTPUT: 'ADD_SHARED_JOURNEY_OUTPUT',
    DELETE_SHARED_JOURNEY_OUTPUT: 'DELETE_SHARED_JOURNEY_OUTPUT',
    // Upgrade
    UPDATE_PROCESS_LIST: "UPDATE_PROCESS_LIST",
    REMOVE_PROCESS_LIST: "REMOVE_PROCESS_LIST",
    UPDATE_ISPROCESSING_STATE: "UPDATE_ISPROCESSING_STATE",
    SET_PROCESSING_LOGGING: "SET_PROCESSING_LOGGING",
    CLEAR_DOWN_UPGRADE_STATE: "CLEAR_DOWN_UPGRADE_STATE",
    CLEAR_DOWN_PROCESS_UPGRADE_STATE: "CLEAR_DOWN_PROCESS_UPGRADE_STATE",
    SET_UPGRADE_CANCEL: "SET_UPGRADE_CANCEL",
    SET_UPGRADE_SETTINGS: "SET_UPGRADE_SETTINGS",
    SET_JESETTINGS_SIDEBAR: "SET_JESETTINGS_SIDEBAR",
    SET_JESETTINGS_SIDEBAR_PROPERTY: "SET_JESETTINGS_SIDEBAR_PROPERTY",
    SET_JESETTINGS_SIDEBAR_JESETTING: "SET_JESETTINGS_SIDEBAR_JESETTING",
    SET_JESETTINGS_SIDEBAR_FORM_VALIDATION_ERROR: "SET_JESETTINGS_SIDEBAR_FORM_VALIDATION_ERROR",
    SET_JESETTINGS_SIDEBAR_SUCCESS: "SET_JESETTINGS_SIDEBAR_SUCCESS",
    SET_JESETTINGS_SIDEBAR_ERROR: "SET_JESETTINGS_SIDEBAR_ERROR",
    UPDATE_PROCESS_ITEM: "UPDATE_PROCESS_ITEM",
    SET_PAGE_MODE: "UPDATE_PAGE_MODE",
    ADD_OR_UPDATE_PANEL: "ADD_OR_UPDATE_PANEL",
    TOOL_SET_TAB: "TOOL_SET_TAB",
    ADD_PANEL_ERRORMESSAGE: "ADD_PANEL_ERRORMESSAGE",
    CLEAR_PANEL_ERRORMESSAGES: "CLEAR_PANEL_ERRORMESSAGES",
    SET_PANEL_LOADING: "SET_PANEL_LOADING",
    SET_SEARCH_FILTERS: "SET_SEARCH_FILTERS",
    SET_PAGING_NUMBER: "SET_PAGING_NUMBER",
    // Tools
    UPDATE_JOURNEY_TITLE: "UPDATE_JOURNEY_TITLE",
    UPDATE_JOURNEY_ID: "UPDATE_JOURNEY_ID",
    SET_TOOLS_STATE: "SET_TOOLS_STATE",
    SET_TOOLS_SAVING: 'SET_TOOLS_SAVING',
    UPDATE_IS_SHARED_JOURNEY: 'UPDATE_IS_SHARED_JOURNEY',
    UPDATE_IS_TRIAGE_JOURNEY: 'UPDATE_IS_TRIAGE_JOURNEY',
    UPDATE_IS_PAGE_JOURNEY: 'UPDATE_IS_PAGE_JOURNEY',
    UPDATE_HIDE_STEPS: 'UPDATE_HIDE_STEPS',
    UPDATE_REPLACE_GUIDS: 'UPDATE_REPLACE_GUIDS',
    UPDATE_SAVE_AND_RESUME: 'UPDATE_SAVE_AND_RESUME',
    ENABLE_EXPERIMENTAL_FEATURES: 'ENABLE_EXPERIMENTAL_FEATURES',
    SET_JOURNEY_PROPERTIES: "SET_JOURNEY_PROPERTIES",
    UPDATE_JOURNEY_PROPERTY: "UPDATE_JOURNEY_PROPERTY",
    ADD_OR_UPDATE_PANEL_VALUE: "ADD_OR_UPDATE_PANEL_VALUE",

    // Outputs
    SET_OUTPUT_STATE: "SET_OUTPUT_STATE",
    UPDATE_OUTPUTS_IN_USE: "UPDATE_OUTPUTS_IN_USE",
    OPEN_OUTPUT_LOOKUP: "OPEN_OUTPUT_LOOKUP",
    CLOSE_OUTPUT_LOOKUP: "CLOSE_OUTPUT_LOOKUP",
    SET_OUTPUT_SEARCH_TERM: "SET_OUTPUT_SEARCH_TERM",
    DELETE_COMPONENT_OUTPUTS: 'DELETE_COMPONENT_OUTPUTS',
    ADD_SHARED_JOURNEY_OUTPUTS: 'ADD_SHARED_JOURNEY_OUTPUTS',
    SET_OUTPUT_SEARCH: 'SET_OUTPUT_SEARCH',
    CLEAR_OUTPUT_SEARCH: 'CLEAR_OUTPUT_SEARCH',
    SET_PREVIOUS_OUTPUT_BLOCKS: 'SET_PREVIOUS_OUTPUT_BLOCKS',
    SET_FOCUSED_OUTPUT_KEY: 'SET_FOCUSED_OUTPUT_KEY',
    UPDATE_OUTPUT_LOOKUP_REQUEST_INDEX: 'UPDATE_OUTPUT_LOOKUP_REQUEST_INDEX',
    SET_INDEX_REQUEST_OUTPUT_ID: 'SET_INDEX_REQUEST_OUTPUT_ID',

    // Cache
    SET_ACTION_TYPES: "SET_ACTION_TYPES",
    ADD_ACTION_TEMPLATE: "ADD_ACTION_TEMPLATE",

    SET_FIELD_TYPES: "SET_FIELD_TYPES",
    SET_ENTITY_FIELDS: "SET_ENTITY_FIELDS",
    SET_ENTITY_VIEWS: "SET_ENTITY_VIEWS",

    SET_COMPONENT_TEMPLATES: "SET_COMPONENT_TEMPLATES",
    SET_COMPONENT_TYPES: "SET_COMPONENT_TYPES",

    SET_CONTROL_TYPES: "SET_CONTROL_TYPES",
    ADD_CONTROL_TEMPLATE: "ADD_CONTROL_TEMPLATE",

    SET_CASE_SERVICE_TYPES: "SET_CASE_SERVICE_TYPES",
    SET_CONTROL_ENTITY_VIEWS: "SET_CONTROL_ENTITY_VIEWS",
    SET_CONTROL_ENTITY_FORMS: "SET_CONTROL_ENTITY_FORMS",
    SET_CONTROL_ENTITY_VIEW_COLUMNS: "SET_CONTROL_ENTITY_VIEW_COLUMNS",
    SET_CONTROL_ENTITY_FORMATTED_ATTRIBUTES: "SET_CONTROL_ENTITY_FORMATTED_ATTRIBUTES",
    SET_CONTROL_FORM_FIELDS: "SET_CONTROL_FORM_FIELDS",
    SET_CONTROL_QUICK_FORMS: "SET_CONTROL_QUICK_FORMS",
    ADD_CONTROL_QUICK_FORM: "ADD_CONTROL_QUICK_FORM",
    ADD_LAYOUT_PANEL: "ADD_LAYOUT_PANEL",
    REMOVE_CONTROL_FIELD_FROM_METADATA: "REMOVE_CONTROL_FIELD_FROM_METADATA",

    SET_OPERATORS_TYPES: "SET_OPERATORS_TYPES",
    SET_OPERATORS: "SET_OPERATORS",

    SET_URLS: "SET_URLS",
    // SET_ACTIONS: "SET_ACTIONS",
    SET_LOADING: "SET_LOADING",

    SET_OUTPUT_TYPES: 'SET_OUTPUT_TYPES',
    UPDATE_SHARED_JOURNEYS: 'UPDATE_SHARED_JOURNEYS',

    SET_REDIRECT_CANDIDATE_TYPE_OPTIONS: "SET_REDIRECT_CANDIDATE_TYPE_OPTIONS",
    ADD_REDIRECT_CANDIDATE_TEMPLATE: "ADD_REDIRECT_CANDIDATE_TEMPLATE",

    // Operation
    SET_SUPPRESS_HASH_CHANGE: "SET_SUPPRESS_HASH_CHANGE",

    // Authentication
    SET_TIMEOUT_WARNING_ID: "SET_TIMEOUT_WARNING_ID",
    SET_TIMEOUT_PASSED: "SET_TIMEOUT_PASSED",

    // UNUSED
    RAISE_ERROR: "RAISE_ERROR",
    CLOSE_ERROR: "CLOSE_ERROR",
    CLEAR_ERROR: "CLEAR_ERROR",

    // UI Active Elements
    SET_NEXT_ACTIVE_ELEMENT: "SET_NEXT_ACTIVE_ELEMENT",
    SET_ACTIVE_SEARCH_LOCATION: "SET_ACTIVE_SEARCH_LOCATION",
    DELETE_ACTIVE_COMPONENT: "DELETE_ACTIVE_COMPONENT",
    DELETE_LOOP_ACTIVE_COMPONENT: "DELETE_LOOP_ACTIVE_COMPONENT",
    SET_ACTIVE_COMPONENTS: "SET_ACTIVE_COMPONENTS",
    UPDATE_ACTIVE_COMPONENTS: "UPDATE_ACTIVE_COMPONENTS",
    ADD_ACTIVE_COMPONENT: "ADD_ACTIVE_COMPONENT",

    // Submission
    UPDATE_SUBMISSION_DIALOG: 'UPDATE_SUBMISSION_DIALOG',
    UPDATE_SUBMISSION: 'UPDATE_SUBMISSION',

    // Global outputs Dialog
    ADD_GLOBAL_OUTPUT: 'ADD_GLOBAL_OUTPUT',
    UPDATE_GLOBAL_OUTPUT: 'UPDATE_GLOBAL_OUTPUT',
    DELETE_GLOBAL_OUTPUT: 'DELETE_GLOBAL_OUTPUT',
    SET_GLOBAL_OUTPUTS_STATE: 'SET_GLOBAL_OUTPUTS_STATE',
    SET_MOVE_FROM_GLOBAL_OUTPUT: 'SET_MOVE_FROM_GLOBAL_OUTPUT',
    SET_MOVE_OVER_GLOBAL_OUTPUT: 'SET_MOVE_OVER_GLOBAL_OUTPUT',
    MOVE_GLOBAL_OUTPUT: 'MOVE_GLOBAL_OUTPUT',

    // Journey Type Dialog
    SET_JOURNEY_TYPES: 'SET_JOURNEY_TYPES',
    UPDATE_JOURNEY_TYPE: 'UPDATE_JOURNEY_TYPE',

    // Summary Dialog
    SET_MOVE_FROM_SUMMARY: 'SET_MOVE_FROM_SUMMARY',
    UPDATE_SUMMARY_OUTPUT: 'UPDATE_SUMMARY_OUTPUT',
    MOVE_SUMMARY_OUTPUT: 'MOVE_SUMMARY_OUTPUT',
    SET_MOVE_OVER_SUMMARY: 'SET_MOVE_OVER_SUMMARY',
    SAVE_SUMMARY_OUTPUTS: 'SAVE_SUMMARY_OUTPUTS',
    SET_SUMMARY_OUTPUTS: 'SET_SUMMARY_OUTPUTS',
    SET_MOVE_GROUP_FROM_SUMMARY: 'SET_MOVE_GROUP_FROM_SUMMARY',
    MOVE_GROUP_SUMMARY_OUTPUT: 'MOVE_GROUP_SUMMARY_OUTPUT',
    SET_MOVE_GROUP_OVER_SUMMARY: 'SET_MOVE_GROUP_OVER_SUMMARY',

    // Redirect Dialog 
    UPDATE_REDIRECT_DIALOG: 'UPDATE_REDIRECT_DIALOG',
    UPDATE_REDIRECT: 'UPDATE_REDIRECT',
    SET_REDIRECT_CANDIDATE_SEARCH: 'SET_REDIRECT_CANDIDATE_SEARCH',
    SET_SELECTED_REDIRECT_CANDIDATE: 'SET_SELECTED_REDIRECT_CANDIDATE',

    // Loop Config
    SET_LOOP_CONFIG: 'SET_LOOP_CONFIG',
    UPDATE_LOOP: 'UPDATE_LOOP',
    DELETE_LOOP: 'DELETE_LOOP',
    UPDATE_LOOP_OUTPUT: 'UPDATE_LOOP_OUTPUT',

    // Settings
    TOGGLE_SETTINGS_SIDEBAR: "TOGGLE_SETTINGS_SIDEBAR",

    // Filter
    ADD_PROPERTY_FILTER_STATE: "ADD_PROPERTY_FILTER_STATE",
    CLEAR_PROPERTY_FILTER_STATE: "CLEAR_PROPERTY_FILTER_STATE",
};


export default types;


// WEBPACK FOOTER //
// ./source/ts/store/types.ts